import { Link } from "gatsby";
import React, { useState } from "react";
import "./ViewpdfRightGrid.scss";
const ViewpdfRightGrid = (props) => {
  const [hoverState1, sethoverState1] = useState(false);
  return (
    <div
      role="presentation"
      onMouseEnter={() => sethoverState1(true)}
      onMouseLeave={() => sethoverState1(false)}
    >
      <Link target="_blank" to={props.VideobannerData.route}>
        {hoverState1 === false ? (
          <img
            className="imageBannerRightGrid img-style"
            src={props.VideobannerData.BannerImage}
            alt={props.VideobannerData.ImageBannerTitle}
          />
        ) : (
          <img
            className="imageBannerRightGrid"
            style={{ width: "100%", height: "868px" }}
            src={props.VideobannerData.HoverImage}
            alt={props.VideobannerData.ImageBannerTitle}
          />
        )}
      </Link>
    </div>
  );
};
export default ViewpdfRightGrid;